import React from 'react'
import { useNavigate } from 'react-router-dom';

function BackButton(props) {
    const navigate = useNavigate();

    return (
        <a href='javascript:void(0)' onClick={props.btnFunction}><i class="fa-solid fa-arrow-left-long me-2"></i>Back</a>
    )
}

export default BackButton